function formatMobile(val) {
  if (!val) return null;
  const s = String(val);
  if (s.length === 10) return `(${s.slice(0, 3)}) ${s.slice(3, 6)}-${s.slice(6)}`;
  return s;
}

const hintCls = 'mt-1.5 text-[11px] text-gray-400 dark:text-slate-500 leading-snug';

export function SchoolHint({ school }) {
  if (!school) return null;
  const location = [school.city, school.state_code].filter(Boolean).join(', ');
  const parts = [school.district_name, location, school.school_type].filter(Boolean);
  if (!parts.length) return null;
  return <p className={hintCls}>{parts.join(' · ')}</p>;
}

export function TeacherHint({ teacher }) {
  if (!teacher) return null;
  const parts = [teacher.email, formatMobile(teacher.mobile)].filter(Boolean);
  if (!parts.length) return null;
  return <p className={hintCls}>{parts.join(' · ')}</p>;
}
